import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";

type Star = {
    id: number;
    x: number;
    y: number;
    size: number;
    opacity: number;
    color: string;
};

type SpaceProp = {
    id: number;
    src: string;
    x: number;
    y: number;
    size: number;
    opacity: number;
    rotation: number;
};

const pastelColors = [
    "#d4b5f9",
    "#f8c8dc",
    "#ffe1a8",
    "#b8d0ff",
    "#ffffff",
];

const propImages = [
    "galaxy_1.png",
    "planet_1.png",
    "planet_2.png",
    "planet_3.png",
    "rocket_1.png",
    "star_1.png",
    // "meteor.png",
    // "moon.png",
    // "satellite.png",
];

const generateStars = (count: number): Star[] => {
    const stars: Star[] = [];
    for (let i = 0; i < count; i++) {
        stars.push({
            id: i,
            x: Math.random() * 100,
            y: Math.random() * 100,
            size: Math.random() * 8 + 1,
            opacity: Math.random() * 0.5 + 0.2,
            color: pastelColors[Math.floor(Math.random() * pastelColors.length)],
        });
    }
    return stars;
};


const generateSpaceProps = (count: number): SpaceProp[] => {
    const props: SpaceProp[] = [];
    for (let i = 0; i < count; i++) {
        props.push({
            id: i,
            src: `/images/props/${propImages[Math.floor(Math.random() * propImages.length)]}`,
            x: Math.random() * 100,
            y: Math.random() * 100,
            size: Math.random() * 30 + 10,
            opacity: Math.random() * 0.5 + 0.1,
            rotation: Math.random() * 360,
        });
    }
    return props;
};

export const Background: React.FC = () => {
    const [stars, setStars] = useState<Star[]>([]);
    const [props, setProps] = useState<SpaceProp[]>([]);
    const location = useLocation();

    useEffect(() => {
        setStars(generateStars(80));
        setProps(generateSpaceProps(20));
    }, [location.pathname]);

    return (
        <div className="min-h-screen  w-full bg-[#002a7b] fixed top-0 left-0 overflow-hidden -z-10"
             style={{pointerEvents: "none"}}
        >
            {stars.map((star) => (
                <div
                    key={star.id}
                    style={{
                        position: "absolute",
                        top: `${star.y}%`,
                        left: `${star.x}%`,
                        width: `${star.size}px`,
                        height: `${star.size}px`,
                        borderRadius: "50%",
                        backgroundColor: star.color,
                        opacity: star.opacity,
                        pointerEvents: "none",
                    }}
                />
            ))}


            {props.map((prop) => (
                <img
                    key={prop.id}
                    src={prop.src}
                    alt="space prop"
                    style={{
                        position: "absolute",
                        top: `${prop.y}%`,
                        left: `${prop.x}%`,
                        width: `${prop.size}px`,
                        opacity: prop.opacity,
                        transform: `rotate(${prop.rotation}deg)`,
                        pointerEvents: "none"
                    }}
                />
            ))}
        </div>

    );
};